import React from 'react'
import Background from './bg.png'

const Landscape = () => {
    return (
        <>
            <img alt='' src={Background} className='background-image' />
        </>
    )
}

export default Landscape